import ReactGAModule from 'react-ga4'

// Vite 8 preserves react-ga4's CommonJS wrapper in development. In that
// environment the GA instance is nested under `default`; older bundlers expose
// the instance directly.
const ReactGA = ReactGAModule.default ?? ReactGAModule

export default ReactGA
